import { z } from "zod";
export const QualityGateWaiverRoleSchema = z.enum(["agency_manager", "platform_operator"]);
export const QualityGateWaiverV1Schema = z
    .object({
    schemaVersion: z.literal("quality-gate-waiver.v1.0"),
    waiverId: z.string().min(1),
    checkId: z.string().min(1),
    reason: z.string().min(1).max(2000),
    authorizedBy: z.string().min(1),
    role: QualityGateWaiverRoleSchema,
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
})
    .strict();
const UNWAIVABLE_SEVERITIES = new Set([
    "BLOCKING",
    "SECURITY",
    "FAIL",
]);
/** QA-010: blocking / security failures cannot be waived. */
export function assertCheckWaivable(check) {
    if (check.passed) {
        throw new Error("cannot_waive_passing_check");
    }
    if (UNWAIVABLE_SEVERITIES.has(check.severity)) {
        throw new Error("cannot_waive_blocking_or_security_check");
    }
}
export function isWaiverActive(waiver, nowIso) {
    return waiver.expiresAt > nowIso;
}
export function createQualityGateWaiver(input) {
    assertCheckWaivable(input.check);
    return QualityGateWaiverV1Schema.parse({
        schemaVersion: "quality-gate-waiver.v1.0",
        waiverId: input.waiverId,
        checkId: input.check.checkId,
        reason: input.reason,
        authorizedBy: input.authorizedBy,
        role: input.role,
        expiresAt: input.expiresAt,
        createdAt: input.createdAt ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=quality-gate-waiver.js.map